import { ApiSimpleSubscription } from "@incendium/api";
import { listSubscriptions } from "features/subscription";
import { useGlobalSharedState } from "Hooks/useSharedState";

const fetchSubscriptions = async () => {
  const subscriptions = await listSubscriptions();
  return subscriptions || [];
};

const useSubscriptions = () => {
  const { state, setState, loading, refetch } = useGlobalSharedState<ApiSimpleSubscription[]>(
    "subscriptions",
    [],
    fetchSubscriptions
  );

  return {
    subscriptions: state,
    setSubscriptions: setState,
    loading,
    refetch,
  };
};

export default useSubscriptions;
